'use client'
import React, { useState } from 'react'
import ReviewCard from '@/components/review-card'
import CustomSwiper from '@/components/custom-swiper'

const TopReviewerSlider = ({ cardDataNew = [], onSlideIndexChange }) => {
  const [activeIndex, setActiveIndex] = useState(0)

  const handleSlideChange = (index) => {
    setActiveIndex(index)
    onSlideIndexChange?.(index)
  }

  return (
    <div className='relative w-full mx-auto overflow-hidden'>
      <div className='2xl:px-[400px] xl:px-[200px] lg:px-[150px] px-0'>
        <CustomSwiper
          slidesToShow={1}
          autoplay
          autoplaySpeed={3000}
          speed={500}
          showDots={false}
          showArrows={false}
          infinite={false}
          onSlideChange={handleSlideChange}
          containerClassName='!overflow-visible'
        >
          {cardDataNew?.map((card, i) => (
            <div
              key={i}
              className={`flex justify-center items-center px-[22px] transition-opacity duration-300 ${i === activeIndex ? 'opacity-100' : 'opacity-50'}`}
            >
              <ReviewCard {...card} />
            </div>
          ))}
        </CustomSwiper>
      </div>
    </div>
  )
}

export default TopReviewerSlider
